var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconIllustrationGroup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61 29c-3.028 0-4 1.094-4 4.5 0 2.666 1.402 5.5 4 5.5s4-2.834 4-5.5c0-3.406-.972-4.5-4-4.5zm0 12c-3.42 0-6-3.225-6-7.5 0-3.026.682-6.5 6-6.5s6 3.474 6 6.5c0 4.275-2.58 7.5-6 7.5z",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A5ADB1",
    d: "M53.515 42.857l-1.03-1.714 5-3 1.03 1.714-5 3M69 49h-6v-2h6c.297 0 1-.776 1-2v-1.42l-6.496-3.712.992-1.736L72 42.42V45c0 2.168-1.374 4-3 4M19 29c-3.028 0-4 1.094-4 4.5 0 2.666 1.402 5.5 4 5.5s4-2.834 4-5.5c0-3.406-.972-4.5-4-4.5zm0 12c-3.42 0-6-3.225-6-7.5 0-3.026.682-6.5 6-6.5s6 3.474 6 6.5c0 4.275-2.58 7.5-6 7.5z",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A5ADB1",
    d: "M26.485 42.857l-5-3 1.03-1.714 5 3-1.03 1.714M17 49h-6c-1.626 0-3-1.832-3-4v-2.58l7.504-4.288.992 1.736L10 43.58V45c0 1.224.703 2 1 2h6v2",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 66h-2v-9c0-8.01 4.446-9.7 9.152-11.488 1.743-.662 3.544-1.347 5.352-2.38l.992 1.736c-1.943 1.111-3.904 1.856-5.633 2.513C22.128 49.181 19 50.369 19 57v9M63 66h-2v-9c0-6.631-3.128-7.819-7.863-9.619-1.729-.657-3.69-1.402-5.633-2.513l.992-1.736c1.808 1.033 3.609 1.718 5.352 2.38C58.554 47.3 63 48.99 63 57v9",
    fill: "#E97025",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 44.882l3.803 1.901 2.91-2.91-1.187-1.78-5.526.921-5.526-.921-1.187 1.78 2.91 2.91L40 44.882zm4.197 4.335L40 47.118l-4.197 2.099-5.09-5.09 2.813-4.22L40 40.986l6.474-1.079 2.813 4.22-5.09 5.09z",
    fill: "#E97025",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E97025",
    d: "M44 41h2v-4h-2zM34 41h2v-4h-2zM39 56h2v-2h-2zM39 52h2v-2h-2z",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 39c-.132 0-3.261-.013-5.447-1.105l-.108-.063c-.137-.092-3.384-2.333-4.435-9.69L30 28v-4h2v3.929c.861 5.917 3.201 7.96 3.519 8.212 1.762.844 4.455.859 4.482.859.025 0 2.717-.015 4.478-.858.313-.25 2.661-2.305 3.521-8.213V24h2l-.01 4.142c-1.051 7.357-4.298 9.598-4.435 9.69l-.108.063C43.261 38.987 40.132 39 40 39M50 24h-2c0-5.532-2.467-8-8-8-5.533 0-8 2.468-8 8h-2c0-6.636 3.364-10 10-10s10 3.364 10 10",
    fill: "#E97025",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E97025",
    d: "M45.045 27.096l-10-4-3.598 1.799-.894-1.79 4.402-2.201 10 4 3.598-1.799.894 1.79-4.402 2.201M25 66h2v-8h-2zM53 66h2v-8h-2z",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h80v80H0z"
  }))));
}

export default SvgIconIllustrationGroup;